/* Newsletter sign-up straight to Klaviyo (README > Klaviyo).
   Any <form data-klaviyo-signup> is sent from the browser to Klaviyo's client subscriptions
   API instead of Shopify's customer form: the footer signup (sections/brents-newsletter.liquid)
   and the announcement-bar modal (snippets/newsletter-modal.liquid). The password page has its
   own copy of this in sections/brents-password-signup.liquid, because that layout does not
   load this file.

   The form carries what it needs:
     data-klaviyo-key     public key / site ID      (theme setting klaviyo_public_key)
     data-klaviyo-list    list the email is added to (theme setting klaviyo_list_id)
     data-klaviyo-source  shows on the profile as the sign-up source, e.g. "Footer"
     [data-klaviyo-status]                       where the result is written
     <template data-message-success|error>       the markup for each result

   After a successful sign-up the browser is identified to Klaviyo's onsite script, so its
   popup can tell this visitor has already subscribed. Without that a footer sign-up left the
   visitor anonymous to Klaviyo and the popup kept asking for the email again. */
(function () {
  var ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/?company_id=';
  var REVISION = '2025-10-15';

  function identify(email) {
    try {
      if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
        window.klaviyo.identify({ email: email });
      } else {
        /* klaviyo.js not loaded yet: it drains this queue when it arrives */
        window._learnq = window._learnq || [];
        window._learnq.push(['identify', { $email: email }]);
      }
    } catch (error) {
      /* identifying is a nicety; the subscription itself already went through */
    }
  }

  function initForm(form) {
    if (form.dataset.ready) return;
    form.dataset.ready = 'true';

    var key = form.dataset.klaviyoKey;
    var list = form.dataset.klaviyoList;
    var source = form.dataset.klaviyoSource || 'Website';
    var input = form.querySelector('input[type="email"]');
    var button = form.querySelector('button[type="submit"]');
    var status = form.querySelector('[data-klaviyo-status]');
    if (!input || !button || !status) return;

    function show(kind, text) {
      var tpl = form.querySelector(kind === 'success' ? '[data-message-success]' : '[data-message-error]');
      if (!tpl) return;
      var node = tpl.content.firstElementChild.cloneNode(true);
      if (kind !== 'success') node.querySelector('[data-message-text]').textContent = text;
      status.innerHTML = '';
      status.appendChild(node);
      input.setAttribute('aria-invalid', kind === 'success' ? 'false' : 'true');
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var email = input.value.trim();
      if (!email || !input.checkValidity()) {
        show('error', 'Please enter a valid email address.');
        input.focus();
        return;
      }
      if (!key || !list || !window.fetch) {
        show('error', 'Sign-up is unavailable right now. Please try again later.');
        return;
      }
      button.disabled = true;
      fetch(ENDPOINT + encodeURIComponent(key), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', revision: REVISION },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: source,
              profile: { data: { type: 'profile', attributes: { email: email } } }
            },
            relationships: { list: { data: { type: 'list', id: list } } }
          }
        })
      })
        .then(function (response) {
          if (response.ok) {
            identify(email);
            show('success');
            form.reset();
            return;
          }
          return response.json().then(
            function (body) {
              var detail = body && body.errors && body.errors[0] && body.errors[0].detail;
              show('error', detail || 'Something went wrong. Please try again.');
            },
            function () {
              show('error', 'Something went wrong. Please try again.');
            }
          );
        })
        .catch(function () {
          show('error', 'Something went wrong. Please try again.');
        })
        .finally(function () {
          button.disabled = false;
        });
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('form[data-klaviyo-signup]').forEach(initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
